const api = require('./api')
const { metrics } = require('lib/radio')

/**
 * Beacon.track
 * helper to trigger a metric event when the beacon is opened from a given URI
 * @param {string} from endpoint where beacon is opened
 * @returns {function} function which can be called to remove the listener
 */
function track(from) {
    if (__DEBUG__ && ! from) throw new Error('Beacon track requires from.')
    const sendMetric = () => {
        metrics.trigger('beacon:open', { from })
    }
    api('on', 'open', sendMetric)

    const untrack = () => {
        api('off', 'open', sendMetric)
    }
    return untrack
}

module.exports = track
